import { FailedToGetData, H2, Loading, RadioSelector } from 'src/components/_commons';
import { LogsCard } from './subcomponents/LogsCard';
import { logServices } from 'src/services';
import { setAlertResponse } from 'src/store';
import { typeLogsDoc } from '@monorepo/models';
import { useDispatch } from 'react-redux';
import { useGetCurrentUser } from 'src/custom-hooks';
import { useState, useEffect, useMemo } from 'react';

export const AdminsLogs = () => {
    const user = useGetCurrentUser();
    //
    const [congregationForLogs, setCongregationForLogs] = useState(user.congregation);
    const [isLoading, setIsLoading] = useState(true);
    const [logs, setLogs] = useState<typeLogsDoc[] | null>(null);
    const [radioValue, setRadioValue] = useState('');
    const dispatch = useDispatch();

    const logsToShow: typeLogsDoc[] = useMemo(() =>
        logs
         ?.filter(l => l.congregation === congregationForLogs)
         .sort((l1, l2) => l1.title.localeCompare(l2.title))
        ?? []
    , [congregationForLogs, logs]);

    const activeLog: typeLogsDoc | null = useMemo(() =>
        logsToShow.find(l => l.type === radioValue) ?? null
    , [logsToShow, radioValue]);

    useEffect(() => {
        logServices.GetAll(false, null, null).then(response => {
            setIsLoading(false);
            if (!response.success || !response.data?.logs) {
                dispatch(setAlertResponse({ response }));
                return;
            }
            setLogs(response.data.logs);
        });
    }, []);

    if (isLoading) {
        return <Loading mt={'80px'} />;
    }

    if (!logs) {
        return <FailedToGetData />;
    }

    return (
        <>
        <H2 title={'LOGS DE LA APLICACIÓN'} />
        {!!logs.length && logs.some(x => !!x.logs?.length) ?
            <>
            {user.isSuperAdmin &&
                <div className={'d-flex justify-content-center'}>
                    <select className={'form-select my-3 maxw-400'}
                        value={congregationForLogs}
                        onChange={e => {
                            setCongregationForLogs(parseInt(e.target.value) || 0);
                            setRadioValue('');
                        }}
                    >
                        {[...new Set(logs?.map(l => l.congregation))].sort((c1, c2) => c1 - c2).map(c =>
                            <option key={c} value={c}>
                                Congregación {c}
                            </option>
                        )}
                    </select>
                </div>
            }
            {[0, 1, 2, 3].map(n =>
                <RadioSelector key={n}
                    additionalKey={`R${n}`}
                    options={logsToShow.slice(n * 5, 5 * (n + 1)).map(l =>
                        ({ label: l.title, type: l.type })
                    ) ?? []}
                    radioValue={radioValue}
                    removeMargin
                    setRadioValue={setRadioValue}
                />
            )}
            </>
            :
            <h4 className={'text-center mt-5'}>
                No hay datos
            </h4>
        }
        {!!activeLog &&
            <LogsCard
                activeLog={activeLog}
                congregationForLogs={congregationForLogs}
                setActiveLog={() => {}}
                setLogs={setLogs}
            />
        }
        </>
    );
}
